import $ from "jquery";
import {debounce} from 'throttle-debounce';

export default class Hero {
    constructor() {
        const calculate = debounce(300, () => {
            $('.hero.has-text').each((i, el) => {
                $(el).css('--text-height', $('.h-text', el).height() + 'px');
            });
        })
        if ($('.hero.has-text').length) {
            calculate();
            window.addEventListener('resize', calculate);
        }
    }

}